// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__28rtK","detailsBorder":"styles_detailsBorder__3K03T"};